import { useUserStore } from '@/store/user'

export function canSeeProviderDetail(): boolean {
  const userStore = useUserStore()
  return Boolean(userStore.canAccessOperations || userStore.canManageConfig || userStore.isApprover)
}
